import { getPropertiesToTrack } from '../tracking/getPropertiesToTrack';
export class StepConfigFactory {
  static getStepConfig(stepKey, data = [], view, {
    hideProgressBar = false,
    hideStepNumber = false,
    hideBackButton = false,
    shouldShowPrivacyBanner = false,
    trackSelectedOption = false,
    isWideStep = false,
    isFramedCentredStep = true,
    getStepPropertiesToTrack = state => getPropertiesToTrack(state)[stepKey],
    waveType,
    shouldShowWavePostAccountCreation = true,
    showMessagingAboveContent = false,
    alignCentredStepAtTheTop = true,
    stepToButtonColumn,
    showNextButtonIcon = true,
    shouldUseBgCirclesIfInAcq143 = false
  } = {}) {
    return {
      hideProgressBar,
      hideStepNumber,
      hideBackButton,
      shouldShowPrivacyBanner,
      trackSelectedOption,
      getStepPropertiesToTrack,
      data,
      stepKey,
      view,
      waveType,
      isWideStep,
      isFramedCentredStep,
      shouldShowWavePostAccountCreation,
      showMessagingAboveContent,
      alignCentredStepAtTheTop,
      stepToButtonColumn,
      showNextButtonIcon,
      shouldUseBgCirclesIfInAcq143
    };
  }
}